module.exports = __webpack_public_path__ + "static/img/mb.4963011.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mb.jpg
// module id = tQBJ
// module chunks = 1